import { render, staticRenderFns } from "./CopyValue.vue?vue&type=template&id=03e1737e"
import script from "./CopyValue.vue?vue&type=script&lang=js"
export * from "./CopyValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports